// extracted by mini-css-extract-plugin
export var externalLink = "_c5-0";
export var internalLinkLabel = "_c5-1";